import { ReactNode } from 'react';
import { GridProps as MuiGridProps } from '@mui/material/Grid';
import { MuiGrid } from '../../../../../../../../modules/material';

export interface SecondLevelCardProps extends Omit<MuiGridProps, 'title'> {
  title: ReactNode;
  price?: ReactNode;
  date?: ReactNode;
}

export default function SecondLevelCard(props: SecondLevelCardProps) {
  const { title, price, date, ...gridProps } = props;

  return (
    <MuiGrid
      container
      columnSpacing={{ xs: 2 }}
      alignItems="center"
      justifyContent="space-between"
      flexWrap="nowrap"
      {...gridProps}
    >
      <MuiGrid container item>
        {date && <MuiGrid item>{date}</MuiGrid>}

        <MuiGrid container item alignItems="center" flexWrap="nowrap">
          <MuiGrid item>{title}</MuiGrid>
        </MuiGrid>
      </MuiGrid>

      {price && <MuiGrid item>{<div>{price}</div>}</MuiGrid>}
    </MuiGrid>
  );
}
